import script from "./DoctorCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorCard.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorCard.vue?vue&type=style&index=0&id=78742211&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78742211"]])

export default __exports__